export default __webpack_public_path__ + "static/media/trc-logo.c39acf17.png";